<app-entity-mat-dialog-title title="Book Student"></app-entity-mat-dialog-title>

<mat-dialog-content>
  <div class="container" [ngClass]="{ 'loading-shade': showProgressSpinner }">
    <mat-progress-spinner class="matProgressSpinnerCentered"
      *ngIf="showProgressSpinner"
      mode="indeterminate"></mat-progress-spinner>

    <div class="row mb-3">
      <div class="col-12">
        <p *ngIf="displayStudentName">Student: <strong>{{ displayStudentName }}</strong>
          <span *ngIf="isCouple" class="badge badge-info ml-2" style="font-size: 0.75em; vertical-align: middle;">Couple</span>
        </p>
        <p *ngIf="data.inquiryDate">Inquiry Date: <strong>{{ data.inquiryDate | date }}</strong></p>
      </div>
    </div>

    <!-- Display error message if any -->
    <div class="row mb-3" *ngIf="errorMessage">
      <div class="col-12">
        <div class="alert alert-danger">
          <mat-icon class="error-icon">error</mat-icon>
          <span class="error-text">{{ errorMessage }}</span>
        </div>
      </div>
    </div>

    <!-- Use the reusable schedule-first-lesson component -->
    <div class="row">
      <div class="col-12">
        <app-schedule-first-lesson
          [(scheduleData)]="scheduleData"
          [hideSubmitButton]="true"
          [hideScheduleToggle]="true"
          [allowedLessonTypeNames]="allowedLessonTypeNames"
          (conflictFound)="onConflictFound($event)"
          (onSubmitSchedule)="onScheduleSubmit($event)"
          (onSuccess)="onSuccessfulBooking()"
          (onError)="onBookingError($event)">
        </app-schedule-first-lesson>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="hasConflicts || !isFormValid() || showProgressSpinner">Book Student</button>
</mat-dialog-actions>
